import { NavLink } from "react-router-dom";

const Navigation = () => (
  <nav>
    <ul style={{ listStyle: "none" }}>
      <li>
        <NavLink to="/">Home</NavLink>
        <NavLink to="/onions">Onions</NavLink>
      </li>
    </ul>
  </nav>
);

export default Navigation;
